import { render, staticRenderFns } from "./copy-to-clipboard.vue?vue&type=template&id=75e85d15"
import script from "./copy-to-clipboard.vue?vue&type=script&lang=js"
export * from "./copy-to-clipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e85d15')) {
      api.createRecord('75e85d15', component.options)
    } else {
      api.reload('75e85d15', component.options)
    }
    module.hot.accept("./copy-to-clipboard.vue?vue&type=template&id=75e85d15", function () {
      api.rerender('75e85d15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/copy-to-clipboard.vue"
export default component.exports